import { render } from "./categoryBlog.vue?vue&type=template&id=8b48b65a&scoped=true"
import script from "./categoryBlog.vue?vue&type=script&lang=js"
export * from "./categoryBlog.vue?vue&type=script&lang=js"

import "./categoryBlog.vue?vue&type=style&index=0&id=8b48b65a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b48b65a"]])

export default __exports__